module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-solutions-for-any-device.en@2x-05b406e0da55637c0947975cefc13956.png";